import tmhRequest from '@/config/tmhRequest'

export default {
    searchServiceOrderReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/serviceorderreport/searchserviceorderreportcount',
            method: 'post',
            data: data,
        })
    },
    searchServiceOrderReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/serviceorderreport/searchserviceorderreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportServiceOrderReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/serviceorderreport/exportserviceorderreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/serviceorderreport.js